var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mb-1 mr-1",attrs:{"elevation":"0","rounded":""},on:{"click":_vm.emitClick}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }